import { layoutSmall } from 'core/util/default'
import React from 'react'
import styled, { css } from 'styled-components'

interface SkeletonBannerProps {}

const SkeletonBanner: React.FC<SkeletonBannerProps> = (props) => {
  return (
    <StyledSkeletonBanner>
      <div className="skeleton" />
    </StyledSkeletonBanner>
  )
}

const StyledSkeletonBanner = styled.div`
  width: 100%;
  height: 320px;
  margin-bottom: 20px;
  ${layoutSmall(css`
    height: auto;
    padding-top: 42.7%;
    margin-bottom: 12px;
  `)};
  z-index: 1;
  .skeleton {
    width: 100%;
    height: 100%;
    background-color: ${(props) => props.theme.skeleton};
    background-image: ${(props) => props.theme.skeletonGradation};
    background-size: 40px 100%;
    background-repeat: no-repeat;
    background-position: left -40px top 0;
    animation: shine 1s ease infinite;
  }
  @keyframes shine {
    to {
      background-position: right -40px top 0;
    }
  }
`
export default SkeletonBanner
